import React, { useEffect, useState } from 'react'
import { Chart as ChartJS, ArcElement, Legend, Colors } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Legend);


const optionsWorkflow = {
    responsive: true,
    plugins: {
        legend: {
            display: true,
            position: 'bottom',
            labels: {
                color: '#9e9e9e',
                align: 'start',
                usePointStyle: true,
                padding: 10,
            },
        },
    },
    cutout: '60%',
};


function PriorityChat({ notComplete, onTimeComplete, delay }) {
    const totalTasks = notComplete + onTimeComplete + delay;

    const hasData = totalTasks > 0;

    const data = {
        labels: ['Not Complete', 'On Time Complete', 'Delay Complete'],
        datasets: [
            {
                data: [notComplete, onTimeComplete, delay], // ✅ numbers, not strings
                backgroundColor: [
                    'rgb(146, 146, 146)',
                    'rgb(100, 207, 92)',
                    'rgb(232, 77, 77)',
                ],
                borderWidth: 0,
            },
        ],
    };
    //dark theme image change
    const [isDarkTheme, setIsDarkTheme] = useState(false);

    useEffect(() => {
        // Check for the theme on initial load
        const currentTheme = document.body.classList.contains("dark-theme");
        setIsDarkTheme(currentTheme);

        // Listen for changes to the body's class (if toggling happens outside this component)
        const observer = new MutationObserver(() => {
            const updatedTheme = document.body.classList.contains("dark-theme");
            setIsDarkTheme(updatedTheme);
        });

        observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });

        // Cleanup observer on component unmount
        return () => observer.disconnect();
    }, []);
    //dark theme image change end
    return (
        <div>
            <>
                <div className='card text-center graph-card h-100 mb-0'>
                    <div className='card-body'>
                        <h5 className='card-title mb-2'>Score Chart</h5>
                        {hasData ?
                            <div className='chart-wrap'>
                                <Doughnut data={data} options={optionsWorkflow} />;
                                <p>Select / Deselect legends</p>
                            </div>
                            :
                            <div className='chart-wrap-nodata'>
                                <img
                                    src={
                                        isDarkTheme
                                            ? `${process.env.PUBLIC_URL}/assets/images/graph-nodata-dark.png`
                                            : `${process.env.PUBLIC_URL}/assets/images/graph-nodata.png`
                                    }
                                    className="img-fluid"
                                    alt="no-data"
                                />
                            </div>
                        }

                        {/* // <div style={{ height: "100%", display: 'flex', justifyContent: "center", alignItems: "center", fontSize: "20px" }}> <p>No Data Found</p></div>

                        } */}
                    </div>
                </div>
            </>
        </div>
    )
}

export default PriorityChat
